/* global __API_ROOT_URL__ */

import angular from 'angular';
import constants from 'app/constants';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _$http;
let _upload;

export class importDataService {
  constructor(
    $http,
    Upload
  ) {
    _$http = $http;
    _upload = Upload;

    this.cache = {};
    console.log('app.services.importDataService created');
  }

  // ///// Import  //////////

  uploadnStageFile(customerId, importEntityTypeId, entityId, file) {
    return _upload.upload({
      url: `${__API_ROOT_URL__}/import/import`,
      data: {
        customerId,
        importEntityTypeId,
        entityId,
        file,
        echo: true
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  processImport(importSetId) {
    return _$http(
      {
        url: `${__API_ROOT_URL__}/import/import/process/${importSetId}`,
        method: 'POST',
        params: { echo: true },
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  getImportDetails(importEntityTypeId, importSetId) {
    return _$http({
      url: `${__API_ROOT_URL__}/import/importEntityType/${importEntityTypeId}/importSetData/${importSetId}`,
      method: 'GET',
    });
  }

  getImportHeaders(importSetId) {
    return _$http({
      url: `${__API_ROOT_URL__}/import/importSet/${importSetId}/importSetHeaderData`,
      method: 'GET',
    });
  }

  getImportMappings(importSetId) {
    return _$http({
      url: `${__API_ROOT_URL__}/import/importSet/${importSetId}/importSetMapping`,
      method: 'GET',
    });
  }

  saveImportMappings(importSetId, mappings) {
    return _$http({
      url: `${__API_ROOT_URL__}/import/importSet/${importSetId}/importSetMapping/saveBulk`,
      method: 'POST',
      data: JSON.stringify(mappings),
      params: { echo: true },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  // ///// General Import //////////
  getImportTemplateFile(importEntityTypeId, entityId) {
    const url = `${__API_ROOT_URL__}/import/importEntityType/${importEntityTypeId}/getTemplate/${entityId}`;

    return _$http({
      url,
      method: 'GET',
    });
  }
}

importDataService.$inject = [
  '$http',
  'Upload'
];

export default angular.module('app.services.importDataService', [
  ngFileUpload,
  constants,
])
  .service('importDataService', importDataService)
  .name;
